import React from 'react';

import Icon from '~/core/scripts/components/Icon';

const ClearIndicator = ({ innerProps }) => (
  <button className="btn btn-clear" {...innerProps}>
    <Icon type="close" />
  </button>
);

ClearIndicator.displayName = 'ClearIndicator';

export default ClearIndicator;
